import Vue from 'vue'

export default Vue.extend({
  methods: {
    toggleArrayItem(
      item: string | number,
      array: Array<string | number>
    ): void {
      const index = array.indexOf(item)
      if (index >= 0) {
        this.$delete(array, index)
      } else {
        array.push(item)
      }
    },
  },
})
